import {
  ADD_SYSTEM_NOTIFICATION,
  HIDE_MESSAGE,
  ON_SYSTEM_NOTIFICATION_CLOSED,
  SHOW_MESSAGE
} from 'constants/ActionTypes'
import uuid from 'uuid/v4'
import { has, is, toString } from 'ramda'

const isString = is(String)
const hasMessage = has('message')
const hasImportant = has('important')
const hasLevel = has('level')

export const showMessage = (val, options = {}) => {
  let text = isString(val) ? val : hasMessage(val) ? val.message : toString(val)

  const isError = val instanceof Error
  let important = options && hasImportant(options) ? options.important : isError
  let level = options && hasLevel(options) ? options.level : isError ? 'error' : 'info'

  return {
    type: SHOW_MESSAGE,
    message: {
      text,
      important,
      level
    }
  }
}

export const clearMessage = () => {
  return {
    type: HIDE_MESSAGE,
  }
}

export const addSystemNotification = ({ level = null, header = null, message = null, details = [] }) => {
  const id = uuid()
  return {
    type: ADD_SYSTEM_NOTIFICATION,
    notification: {
      id,
      level,
      header,
      message,
      details
    }
  }
}

export const onSystemNotificationClosed = (notificationId) => {
  return {
    type: ON_SYSTEM_NOTIFICATION_CLOSED,
    notificationId: notificationId
  }
}



// WEBPACK FOOTER //
// ./actions/Notifications.js